module.exports = "//static.hsappstatic.net/ContentComponents/static-2.63389/img/content-remix-post-publish/content-remix-de.png"